import {css} from '@emotion/react';

export const layeredModal = css`
  div[class$="overlay-container"] {
    z-index: 10000;
  }
`;
